import { render, staticRenderFns } from "./addBuild.vue?vue&type=template&id=13255474&"
import script from "./addBuild.vue?vue&type=script&lang=js&"
export * from "./addBuild.vue?vue&type=script&lang=js&"
import style0 from "./addBuild.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports